require([
    'jquery',
    'semantic',
    'services',
    'ch_modal_window',
    'ch_form_validation',
    'ch_header',
    'ch_semantic_responsive'
], function () {
    $(function () {
        var courseChanged = $._('course').val() != 0;
        var characterCounterElem = $._('characters-remaining');
        var maxCount = 2500;
        CH.semantic_form_validation = true;

        // Reset counter upon failure submission
        if ($._('review_text').val().length > 0) {
            characterCounter($._('review_text'), maxCount, characterCounterElem);
        }

        $._('new_date_section').hide();
        $._('new_course_section').hide();
        $('.ui.rating').rating({
                initialRating: ($._('number_of_stars').length ? $._('number_of_stars').val() : 0),
                maxRating: 5,
                onRate: function (val) {
                    $._('number_of_stars').val(val);
                    if (val > 0) $._('number_of_stars').valid();
                },
            });

        CH.validate('form_ExternalProviderReview', {
            rules: {
                dates: {
                    required: false,
                    usDateFormat: false,
                },
            },
            submitHandler: function (form) {
                $('body').maskElement('');
                $.ajax({
                    url: form.action,
                    type: 'POST',
                    data: $(form).serialize(),
                    dataType: 'json',
                    success: function (res) {
                        $('body').unmaskElement('');
                        if (!res.success && res.error) {
                            swal({
                                title: res.error,
                                type: 'error',
                                confirmButtonText: 'OK',
                                closeOnConfirm: true, });
                            return;
                        }

                        ga(
                            'send',
                            'event',
                            'School Review Program',
                            'Review Submitted',
                            $('#provider option:selected').text(),
                            { nonInteraction: false }
                        );
                        var sweetAlertTitle = 'Thanks for leaving a review for your ' +
                            $('#provider option:selected').text() +
                            ' class on CourseHorse!';
                        swal({
                            title: sweetAlertTitle,
                            type: 'success',
                            confirmButtonText: 'OK',
                            closeOnConfirm: true, },
                            function () {
                                window.location.reload();
                            });
                    },
                });
            },
        });
        $._('course').dropdown({
                onChange: function (val) {
                    courseChanged = true;
                    if (val != 0) {
                        $._('section').dropdown('clear');
                        $._('new_course_section').hide();
                    } else {
                        $._('new_course_section').show();
                    }
                },
            });
        $._('section').dropdown({
            onShow: function () {
                if (courseChanged) {
                    $._('section').empty();
                    $._('section').append('<option value="' + 0 + '">Not Listed</option>');
                    if (($._('course').val() != 0)) {
                        $.ajax({
                            url: '/provider/get-course-sections',
                            type: 'GET',
                            async: false,
                            dataType: 'json',
                            data: {
                                course_id: $._('course').val(),
                            },
                            success: function (res) {
                                if (res.success) {
                                    var section;
                                    for (var i = 0; i < res.data.length; i++) {
                                        section = res.data[i];
                                        $._('section').append(
                                            '<option value="' + section.id + '">' +
                                                section.start_datetime + '</option>'
                                        );
                                    }
                                }
                            },
                        });
                        courseChanged = false;
                    }

                    $._('section').dropdown('refresh');
                    $._('section').dropdown('clear');
                }
            },

            onChange: function (val) {
                if (val != 0) {
                    $._('new_date_section').hide();
                } else {
                    $._('new_date_section').show();
                }
            },
        });
        $._('make_me_anonymous').change(function () {
            if ($._('make_me_anonymous').is(':checked')) {
                $._('name').rules('remove', 'required');
            } else {
                $._('name').rules('add', 'required');
            }
        });

        $._('review_text').on('input', function (e) {
            characterCounter(this, maxCount, characterCounterElem);
        });

        ga('send', 'event', 'School Review Program', 'Page Viewed', $('#provider option:selected').text(), {
            nonInteraction: true,
        });
    });
});
